import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { Button, FormGroupRow, Modal } from '../../../../common/components';
import { closeModal, openModal } from '../../../../common/components/Modal/ModalRedux';
import { actions } from '../../redux/brokerActions';
import { get, set } from 'lodash';
import './styles.scss';
import { Row, Col } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import AsyncSelectMenu from '../../../../common/components/SelectMenu/AsyncSelectMenu';

const FORM_NAME = 'transferBrokerForm';

const validate = (values) => {
  const errors = {};

  if (!get(values, 'data.relationships.broker.data.id')) {
    set(errors, 'data.relationships.broker.data.id', 'Broker is required');
  }

  if (!get(values, 'data.relationships.user.data.id')) {
    set(errors, 'data.relationships.user.data.id', 'User is required');
  }

  return errors;
};

class TransferBrokerButton extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired,
    resource: PropTypes.object.isRequired,
    resourceType: PropTypes.string.isRequired,
    broker: PropTypes.object,
    user: PropTypes.object,
    callback: PropTypes.func,
    label: PropTypes.string,
  };

  componentWillUpdate(newProps) {
    const { dispatch, submitSucceeded, callback } = this.props;
    if (newProps.submitSucceeded && !submitSucceeded) {
      if (callback) {
        callback('');
      }
      dispatch(closeModal(FORM_NAME));
    }
  }

  handleSubmit(values) {
    const { actions, resource, resourceType } = this.props;
    return actions.transferBroker(values, resource, resourceType);
  }

  handleOpen() {
    const { dispatch, reset } = this.props;
    dispatch(reset());
    dispatch(openModal(FORM_NAME));
  }

  render() {
    const { label, handleSubmit, submitting, formValues } = this.props;
    const title = label || 'Transfer';
    const submitButton = (
      <Button
        type="submit"
        bsStyle="primary"
        disabled={submitting}
        isLoading={submitting}
        label="Transfer"
      />
    );

    return (
      <div className="email-btn-wrapper pull-right">
        <Button
          bsStyle="primary"
          label={title}
          rightIcon="exchange"
          handleClick={::this.handleOpen}
        />

        <Modal
          name={FORM_NAME}
          title={title + ' Broker'}
          close={true}
          handleSubmit={handleSubmit(::this.handleSubmit)}
          footer={submitButton}
        >
          <Row>
            <Col sm={12}>
              <p>Please select a Broker to transfer this Broker to.</p>

              <FormGroupRow label="Broker" labelSize={3}>
                <Field
                  name={'data.relationships.broker.data.id'}
                  optionValuePath={'id'}
                  url={'/brokers?'}
                  filters={[{ type: 'broker_type', match: 'broker' }]}
                  component={AsyncSelectMenu}
                />
              </FormGroupRow>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroupRow label="User" labelSize={3}>
                <Field
                  name={'data.relationships.user.data.id'}
                  optionValuePath={'id'}
                  labelPath={'attributes.full_name'}
                  url={'/users?'}
                  key={'User' + get(formValues, 'data.relationships.broker.data.id')}
                  filters={[
                    {
                      type: 'broker',
                      match: get(formValues, 'data.relationships.broker.data.id'),
                    },
                  ]}
                  component={AsyncSelectMenu}
                />
              </FormGroupRow>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

const form = reduxForm({ form: FORM_NAME, validate })(TransferBrokerButton);

const selector = formValueSelector(FORM_NAME);

export default connect(
  (state, props) => {
    const values = selector(
      state,
      'data.relationships.broker.data.id',
      'data.relationships.user.data.id',
    );

    return {
      initialValues: {
        data: {
          relationships: {
            broker: {
              data: {
                id: get(props.broker, 'data.id', ''),
              },
            },
            user: {
              data: {
                id: get(props.user, 'data.id', ''),
              },
            },
          },
        },
      },
      formValues: values,
    };
  },
  (dispatch) => {
    return {
      actions: bindActionCreators(actions, dispatch),
    };
  },
)(form);
